import { regex } from 'const/nuclias/regex';

export const defaultPathList = [
  { label: 'f4f70727dc', isLink: false },
  { label: 'a6e7cd29c1', isLink: false },
  { label: 'a35df53e36', isLink: false },
];

export const tableColumn = [
  { label: '49ee308734', accessor: 'name', sortable: true },
  { label: '2611bdb264', accessor: 'syslogServer', sortable: true },
  { label: '716f54f97a', accessor: 'syslogServerPort', sortable: true },
  { label: '888a77f5ac', accessor: 'protocol', sortable: true },
  { label: 'a7d6475ec8', accessor: 'siteListLength', sortable: true }
]

export const defaultAllItem = { id: 0, isAll: true, title: 'b1c94ca2fb', checked: false };

export const defaultModalStatus = {
  addOrEdit: {
    type: 'addOrEdit',
    status: false,
  },
  delete: {
    type: 'delete',
    status: false,
  },
};

export const syslogServerField = {
  name: 'name',
  server: 'server',
  port: 'port',
  protocol: 'protocol',
  site: 'site'
};

export const defaultSyslogServerState = {
  [syslogServerField['name']]: {
    value: '',
    required: true,
    minLength: 1,
    maxLength: 64,
    dirty: false,
    valid: false
  },
  [syslogServerField['server']]: {
    value: '',
    required: true,
    regex: regex.ipAddressAndHostname,
    dirty: false,
    valid: false
  },
  [syslogServerField['port']]: {
    value: 514,
    required: true,
    min: 1,
    max: 65535,
    dirty: false,
    valid: false
  },
  [syslogServerField['protocol']]: {
    list: [],
    selected: null
  },
  [syslogServerField['site']]: {
    list: [],
  },
};